import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import swal from 'sweetalert2';

import { environment } from '../../environments/environment';
import { ServicesService } from '../services/services.service';

@Component({
  selector: 'app-delivery',
  templateUrl: './delivery.component.html',
  styleUrls: ['./delivery.component.css']
})
export class DeliveryComponent implements OnInit {

  fields:any=[];
	listData:any=[];
	clientListData:any=[];
	cid:string;	
	clientName:string;

	public loading = false;
  	public show:boolean = false;
  	apiBaseUrl = environment.apiBaseUrl;

  spinLoader = {
    filter : false,
    delete : []
  };

  isListData=true;
  isOnePage=true;
  backDiv=false;
  isCid=false;
  isListDataEmpty=false;
  cname:any;

  constructor(private route:ActivatedRoute, private router:Router,private _services: ServicesService) {
    this.route.queryParams.subscribe(params=>{
    this.cid = params['cid'];
    this.cname = params['cname'];
    })
  }
 
  ngOnInit() {
    this._services.checkToken('status');
    if(this.cid != undefined){
      //console.log(this.cid);
      this.isCid=true;
      this.backDiv = true;
      this.clientName=this.cname;
    }else{
      this.backDiv = false;
    }

    this.getOrderProjectList();
    this.fields = [
            {
                'field' : 'delivery_no',
                'title' : 'Delivery no',
                'width' : '20%',
                'code'  : true,
                'sort'  : false
            },
            {
                'field' : 'client_name',
                'title' : 'Client Name',
                'width' : '20%',
                'code'  : true,
                'sort'  : true
            },
            {
                'field' : 'delivery_date',
                'title' : 'Expected Delivery Date',
                'width' : '20%',
                'code'  : false,
                'sort'  : false
            },
            {
              'field' : 'delivered_timestamp',
              'title' : 'Delivered Date (M)',
              'width' : '15%',
              'code'  : false,
              'sort'  : false
          },
          {
              'field' : 'delivery_status',
              'title' : 'Delivery Status',
              'width' : '15%',
              'code'  : false,
              'sort'  : false
          }
        ]
        
this.getPageRequest();
  }

  resetSearchField(){
    this.searchFields=[''];
    this.searchProjectId='';
    this.getPageRequest();
  }

  getSearchRequest(){
    this.spinLoader['filter'] = true;
    this.getPageRequest();
  }  

  sortType : string = '';
  sortField: string = '';
  oldField: string;
  sortingData= {
      'field' : '',
      'type'  : ''
  };
  sortBy(field, event){

    this.oldField = (this.oldField != field) ? this.oldField : field;

    if(typeof this.oldField !== 'undefined'){
      ////console.log(document.getElementById('fa-'+this.oldField));
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-up');
      document.getElementById('fa-'+this.oldField).classList.remove('fa-sort-down');
      document.getElementById('fa-'+this.oldField).classList.add('fa-sort');
	}
	
    event.target.classList.add('fa');

    this.sortField = field;
    this.sortType = (this.sortType == 'desc') ? 'asc' : 'desc';

    switch(this.sortType){
      case 'desc' : {
        event.target.classList.remove('fa-sort-up');
        event.target.classList.add('fa-sort-down');
        this.oldField = field;
      }break;
      case 'asc'  : {
        event.target.classList.remove('fa-sort-down');
        event.target.classList.add('fa-sort-up');
        this.oldField = field;
      }break;
      default     : {
        event.target.classList.add('fa-sort');
      }
	}
	
    this.sortingData = {
      'field' : this.sortField,
      'type'  : this.sortType
		};
		
    this.getPageRequest();
  }

  /*------------------------------Table with Sorting Ends Here--------------------------*/

  /*------------------------------Pagination Integration Starts Here------------------------*/
  currentPage: number = 1;
  loader: boolean = false;
  paginate= {
    'last_page' : 1
  };
  searchFields= [];
  pages: any;
//   listData = [];
  editData: Object = {};

  previousPage(){
    if(this.currentPage == 1){
      return;
    }

    this.currentPage = this.currentPage -1;
    ////console.log(this.currentPage);return;
    this.getPageRequest();

  }

  nextPage() {

    if (this.paginate.last_page-1 < this.currentPage) {
      return;
    }

    this.currentPage ++;
    //console.log(this.currentPage);
    this.getPageRequest();
  }

  changePage(){

    this.currentPage = this.currentPage;
    ////console.log(this.currentPage);return;
    this.getPageRequest();
  }

  getPages(n){
    if(n>1){
      this.isOnePage=true;
    }else{
      this.isOnePage=false;
    }
    var data = [];
    for (var i = 1; i <= n; i++) {
      data.push(i);
    }
    this.pages = data;
  }
  
  /*------------------------------Pagination Integration Starts Here------------------------*/
routeData:string;
totalData:any;
  getPageRequest(){
  this.spinLoader['filter'] = true;
	let data;
	this.routeData = 'get-delivery-list';
    switch(this.routeData){
	
      case 'get-delivery-list':{
        data = {
            page  : this.currentPage,
            search: {
        'delivery_no' : this.searchFields['delivery_no'],
        'client_name' : this.searchFields['client_name'],
            },
        sort  : this.sortingData,
        project_order_id:this.searchProjectId?this.searchProjectId:'',
        client_id : this.cid
      };
        break;
      }
    }
    
	this.loading = true;
	const token    = localStorage.getItem('userToken');
	this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
    if(this._services.checkToken(result.status)){
      this.spinLoader['filter'] = false;
      this.isListData=false;

      this.listData=[{'client_name':''}];
      this.listData = result.result;
      this.totalData = result.paginate.total;
      this.paginate = result.paginate;

      this.currentPage = result.paginate.current_page;

      if(this.listData.length==0){
        this.isListDataEmpty=true;
      }else{
        this.cid ?this.clientName=this.listData[0].client_name:'';
        this.isListDataEmpty=false;    
      }
      
      if(result.paginate.current_page > result.paginate.last_page){
      this.currentPage = result.paginate.last_page;
      }
      this.getPages(this.paginate.last_page);
    }
		});
    return true;
  }


  orderProjectList:any;
  getOrderProjectList(){
    let data;
    this.routeData = 'get-project-order-list';

    switch(this.routeData){

      case 'get-project-order-list':{
        data = {
          page  : this.currentPage,
          search: {
            'project_name' : this.searchFields['project_name'],
          }
        };
        break;
      }
    }
    const token = localStorage.getItem('userToken');
    this._services.requestCreator(data, this.routeData, token).subscribe((result: any) => {
      if(this._services.checkToken(result.status)){
        // //console.log(result.result);
        this.orderProjectList = result.result;
        // //console.log(this.orderProjectList);
      }
    });

    return true;
  }


  searchProjectId:any='';
  searchProjectOrder(event){
    //console.log(event.target.value);
    this.searchProjectId = event.target.value;
    this.getPageRequest();
  }


}
